export default {"src":"/_next/static/media/arrow_down.d4252493.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};